import { BTSelectItem } from "types/apiResponse/apiResponse";

import { LeadActivityIcon } from "./leadActivityIcon";

export const leadActivityIconClassMap: { [key: number]: string } = {
    [LeadActivityIcon.None]: "",
    [LeadActivityIcon.PhoneCall]: "fa fa-phone",
    [LeadActivityIcon.Email]: "fa fa-envelope-o",
    [LeadActivityIcon.WebsiteForm]: "fa fa-laptop",
    [LeadActivityIcon.Meeting]: "fa fa-calendar",
    [LeadActivityIcon.FollowUp]: "fa fa-check-square-o",
    [LeadActivityIcon.Users]: "fa fa-user-plus",
    [LeadActivityIcon.Flag]: "fa fa-flag-o",
    [LeadActivityIcon.Drop]: "fa fa-tint",
    [LeadActivityIcon.File]: "fa fa-file-o",
    [LeadActivityIcon.Comments]: "fa fa-comments-o",
};

/**
 *  Extends BTSelectItem to add icon class to each item
 */
export class IconSelectItem extends BTSelectItem {
    constructor(item: BTSelectItem) {
        super(item);
        this.className = leadActivityIconClassMap[this.value] || "";
    }
    className: string;
}
